import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import features from '../../constants/features-per-country'
import { SITE_ID } from '../../constants'
import { Title, LeftContent, RightContent, IconButtonsContainer } from './mixins'
import { useConfig } from '../../hooks/config-hook'
import { featureConfig } from '../../constants/config/enum-config'
import Logo from './components/Logo'
import BackButton from './components/BackButton'
import Avatar from './components/Avatar'
import PublishButton from './components/PublishButton'
import ShoppingCart from './components/ShoppingCart'
import HelpButton from './components/HelpButton'
import LinkInbox from './components/LinkInbox'
import { useCurrentUser } from '../../hooks/current-user-hook'
import { useHistoryLocationBumi } from '../../hooks/bumi/history-location-hook'

const defaultTitle = 'Empresas'
const dashboardPaths = ['/empresas/dashboard', '/empresas/inicio', '/empresas/mensajes']

const HeaderInfoContent = ({ showTitle, title, isMobile, showBackButton }) =>
  showTitle ? (
    <LeftContent>
      {showBackButton && <BackButton />}
      <Title showBackButton={showBackButton}>{title || defaultTitle}</Title>
    </LeftContent>
  ) : (
    <LeftContent>{!isMobile && <Logo />}</LeftContent>
  )

const Component = ({ showTitle, title }) => {
  const location = useLocation()
  const { isMobile } = useScreenSize()
  const { userData, canPublish } = useCurrentUser()
  const { config } = useConfig()

  const mensajesEnabled = config[featureConfig.MENSAJES_EMPRESAS]

  const isDashboard = useMemo(
    () => dashboardPaths.some((path) => location.pathname.startsWith(path)),
    [location.pathname]
  )

  const isEcommerceLandingProducts = useMemo(
    () => location.pathname.startsWith('/empresas/compra-online'),
    [location.pathname]
  )

  const isAvisos = useMemo(() => location.pathname.startsWith('/empresas/avisos/listado'), [location.pathname])
  const isRecomendados = useMemo(() => location.pathname.startsWith('/empresas/recomendados'), [location.pathname])

  const newEcommerceEnabled = features[SITE_ID || 'BMAR']?.newEcommerce?.enabled
  const showHelpButton = useMemo(() => !isMobile, [isMobile])
  const showCartButton = useMemo(() => newEcommerceEnabled && canPublish, [newEcommerceEnabled, canPublish])
  const showIconButtons = showCartButton || showHelpButton
  const showMessageButton = useMemo(() => !isMobile && mensajesEnabled, [isMobile, mensajesEnabled])

  const showButtonCrearAviso = canPublish && (isDashboard || isEcommerceLandingProducts || isAvisos)

  const { comesFromPageBumi: bumi } = useHistoryLocationBumi()
  const showBackButton = !bumi || isRecomendados

  return (
    <>
      <LeftContent>
        <HeaderInfoContent showTitle={showTitle} title={title} isMobile={isMobile} showBackButton={showBackButton} />
      </LeftContent>
      <RightContent>
        {showButtonCrearAviso && <PublishButton />}
        {showIconButtons && (
          <IconButtonsContainer>
            {showHelpButton && <HelpButton />}
            {showMessageButton && <LinkInbox />}
            {showCartButton && <ShoppingCart />}
          </IconButtonsContainer>
        )}
        {userData && <Avatar />}
      </RightContent>
    </>
  )
}

const state = ({ headerStore }) => {
  const { title } = headerStore || {}
  return { title }
}
export default connect(state)(Component)
